module.exports = __webpack_public_path__ + "static/Gorgon-9ce4e1c708e23bc12ef1842fd8391e0d.jpg";